import { FlowConditionList } from './types.flow';

import { DEFAULT_ALL_SHOULD_BE_TRUE } from '~/scenes/Automation/Flows/Actions/Base/FlowConditionList/expressionHelpers';

export default (): FlowConditionList => ({
  allShouldBeTrue: DEFAULT_ALL_SHOULD_BE_TRUE,
  conditions: [],
});
